document.addEventListener('DOMContentLoaded', () => {
    const tabNavItems = document.querySelectorAll('.js-tab-nav');
    const tabContents = document.querySelectorAll('.js-tab');

    tabNavItems.forEach((tabNav, index) => {
        tabNav.addEventListener('click', (event) => {
            event.preventDefault();

            // Remove active class from all tab nav items
            tabNavItems.forEach(item => item.classList.remove('active'));

            // Add active class to the clicked tab nav item
            tabNav.classList.add('active');

            // Hide all tab contents
            tabContents.forEach(content => content.classList.remove('active'));

            // Show the corresponding tab content
            if (tabContents[index]) {
                tabContents[index].classList.add('active');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const tabsNavItems = document.querySelectorAll('.js-tab-n');
    const tabsContents = document.querySelectorAll('.js-tab-inner');

    tabsNavItems.forEach((tabsNav, index) => {
        tabsNav.addEventListener('click', (event) => {
            event.preventDefault();

            // Toggle active class on the clicked tab nav item
            tabsNav.classList.toggle('tab-active');

            // Toggle the corresponding tab content
            if (tabsContents[index]) {
                tabsContents[index].classList.toggle('tab-active');
            }
        });
    });
});
